const queryString = require("query-string");

import React from "react";
import ReactDOM from "react-dom";
import { ToastContainer } from 'react-toastify';
// import axe from "react-axe";
import { BrowserRouter, Redirect, Route, Router, Switch } from "react-router-dom";
import Loader from 'react-loader';
//import {hot} from "react-hot-loader";
import 'react-toastify/dist/ReactToastify.css';
import store from "store";
// import { baseUrl, appInsightKey } from "Config";
import AuthService from "./services/AuthService/";
// import CacheService from "./services/Cache/CacheService";
import { LATEST_FEEDS_STATE } from "./constants";
// Styles
// Import Font Awesome Icons Set
import "font-awesome/css/font-awesome.min.css";
// Import Simple Line Icons Set
import "simple-line-icons/css/simple-line-icons.css";
// Import Main styles for this application
import "../scss/style.scss";

// Containers
import Full from "./containers/Full/";

// Views
import Login from "./views/Pages/Login/Login";
import LoginApi from "./views/Pages/Login/LoginApi";
import Page404 from "./views/Pages/Page404/";
import Page500 from "./views/Pages/Page500/";
import Disclaimer from "./views/Pages/Disclaimer";
import Register from "./views/Pages/Register";
import CreatePassword from "./views/Pages/CreatePassword";
import ForgottenPassword from "./views/Pages/ForgottenPassword";
import ResetPassword from "./views/Pages/ResetPassword";
import VerificationFailure from "./views/Pages/VerificationFailure";
import TokenLogin from "./views/Pages/TokenLogin";
import ConfirmCompliance from "./views/Pages/ConfirmCompliance";
import ComplianceVerificationFailure from "./views/Pages/ComplianceVerificationFailure";

import RouteChangeHandler from "./services/RouteServices/RouteChangeHandler";
import history from "./services/AIservice/AIservice";

import 'react-toastify/dist/ReactToastify.css';
// if (process.env.NODE_ENV === "local") {
//   axe(React, ReactDOM, 1000);
// }

const PrivateRoute = ({ component: Component, ...rest }) => {


  if (AuthService.isLoggedIn()) {
    RouteChangeHandler.handleRouteChange(rest);
    return <Route {...rest} render={(props) => <Component {...props} />} />;
  } else {
    const qString = queryString.parse(window.location.search);

    if (qString["api-key"]) {
      AuthService.clear();
      return <Route {...rest} render={(props) => <Redirect to={{ pathname: "/login-api", state: { from: props.location } }} />} />;
    } else {
      return <Route {...rest} render={(props) => <Redirect to={{ pathname: "/login", state: { from: props.location } }} />} />;
    }
  }
};

AuthService.initService();
store.remove(LATEST_FEEDS_STATE);

// clearing all the cached items from localstorage to ensure that it doesn't load stale data on next page open
window.addEventListener("unload", function (event) {
  localStorage.removeItem("colleagues");
  localStorage.removeItem("taxonomy");
  localStorage.removeItem("serviceLines");
  localStorage.removeItem("serviceLinesFlat");
  localStorage.removeItem("documentTypes");
  localStorage.removeItem("jurisdiction");
  localStorage.removeItem("tags");
  localStorage.removeItem("regulatoryCategories");
  localStorage.removeItem("regulators");
  localStorage.removeItem("savedSearches");
});

class App extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      show: false
    }
    this.init()
  }

  init() {
    AuthService.checkIfUserIsLoggedIn().then(resp => {
      this.setState({ show: true });
    }).catch(resp => {
      this.setState({ show: true }, () => {
        AuthService.clear();
        // if (!window.location.href.includes('login')) window.location.href = '/login';
      });
    });
  }
  render() {
    if (!this.state.show) return <Loader color='#BD2E2A' scale={1.5} loaded={this.state.loaded} top="300px" left="50%" />
    return (
      <div>
        <Router history={history}>
          <Switch>
            <Route path="/login" name="Login Page" component={Login} />
            <Route path="/login-api" name="Login Page" component={LoginApi} />
            <Route path="/404" name="Page 404" component={Page404} />
            <Route path="/500" name="Page 500" component={Page500} />
            <Route path="/disclaimer" name="Disclaimer" component={Disclaimer} />
            <Route path="/register" name="Register" component={Register} />
            <Route path="/create-password" name="CreatePassword" component={CreatePassword} />
            <Route path="/forgotten-password" name="ForgottenPassword" component={ForgottenPassword} />
            <Route path="/reset-password/:token" name="ResetPassword" component={ResetPassword} />
            <Route path="/verification-failure" name="VerificationFailure" component={VerificationFailure} />
            <Route path="/token_login/" name="TokenLogin" component={TokenLogin} />

            <Route path="/confirm-compliance/:token" name="ConfirmCompliance" component={ConfirmCompliance} />
            <Route path="/verify-compliance-failure" name="ComplianceVerificationFailure" component={ComplianceVerificationFailure} />

            <PrivateRoute path="/home" name="My Dashboard" component={Full} />
            <PrivateRoute path="/latest/detail" name="Item Detail" component={Full} />

            <PrivateRoute path="/RegulatoryAnalysis/DocumentDetails" name="Item Detail Doc" component={Full} />
            <PrivateRoute path="/RegulatoryAnalysis/EnforcementDetails" name="Item Detail Enf" component={Full} />

            {/* <PrivateRoute path="/latest" name="Latest Feeds" component={Full} /> */}
            <PrivateRoute path="/covid" name="Covid" component={Full} />
            <PrivateRoute path="/dashboard" name="Dashboard" component={Full} />
            <PrivateRoute exact path="/alerting" name="Alerting" component={Full} />
            <PrivateRoute exact path="/alerting-create/:from_search?" name="AlertingCreate" component={Full} />
            <PrivateRoute exact path="/alerting-edit" name="AlertingEdit" component={Full} />
            <PrivateRoute path="/assessments/list" name="MyCases" component={Full} />
            <PrivateRoute path="/all-tasks/list" name="ClientReviews" component={Full} />
            <PrivateRoute path="/all-assessments/list" name="ClientCases" component={Full} />
            <PrivateRoute path="/assessments/new" name="NewCase" component={Full} />
            <PrivateRoute path="/assessments/edit/:id" name="EditCase" component={Full} />
            <PrivateRoute path="/assessments/business-map/:id" name="CaseBusinessMap" component={Full} />
            <PrivateRoute path="/tasks/list" name="MyReviews" component={Full} />
            <PrivateRoute path="/risk-outlook/:id?" name="DataVisualisation" component={Full} />
            <PrivateRoute path="/regulatory-analysis" name="RegulatoryAnalysis" component={Full} />
            <PrivateRoute path="/rri" name="HeatMap" component={Full} />
            <PrivateRoute path="/controls-analysis" name="ControlsAnalysis" component={Full} />
            <PrivateRoute path="/regulation-profiler" name="RegulationProfiler" component={Full} />
            <PrivateRoute path="/-tagging/:code?" name="RegulatiTaggingonList" component={Full} />

            {/* <PrivateRoute path="/regulation" name="RegulatorBookRegulators" component={Full} /> */}
            <PrivateRoute path="/regulation" name="RegulationVersioning" component={Full} />

            <PrivateRoute path="/regulation-books/:regulatorId/" name="RegulatorBookBooks" component={Full} />
            <PrivateRoute path="/books/:bookId/sections" name="RegulatorBookChapters" component={Full} />
            <PrivateRoute path="/chapters/:chapterId" name="RegulatoryChapterBlocks" component={Full} />

            {/* <PrivateRoute path="/search-manager2" name="SearchManager" component={Full} /> */}
            <PrivateRoute path="/search" name="Search" component={Full} />
            <PrivateRoute path="/search-manage" name="Manage Saved Searches" component={Full} />
            <PrivateRoute path="/models/update/:id?" name="ModelsUpdate" component={Full} />
            <PrivateRoute path="/models/create" name="ModelsCreate" component={Full} />
            <PrivateRoute path="/models" name="Models" component={Full} />

            <PrivateRoute path="/corlytics-updates" name="Corlytics Updates" component={Full} />


            {/* <PrivateRoute path="/models-new/update/:id?" name="ModelsNewUpdate" component={Full} />
            <PrivateRoute path="/models-new/create" name="ModelsNewCreate" component={Full} /> */}
            {/* Taxonomy mapping routes */}
            <PrivateRoute path="/taxonomy-mapping/details/:client/:id?" name="TaxonomyDetails" component={Full} />
            <PrivateRoute path="/taxonomy-mapping/documents/:client/:id" name="TaxonomyDocuments" component={Full} />
            <PrivateRoute path="/taxonomy-mapping/category-structure/:client/:id" name="CategoryStructure" component={Full} />
            <PrivateRoute path="/taxonomy-mapping/category-mapping/:client/:id" name="CategoryMapping" component={Full} />
            <PrivateRoute path="/taxonomy-mapping/service-line-structure/:client/:id" name="ServiceLineStructure" component={Full} />
            <PrivateRoute path="/taxonomy-mapping/service-line-mapping/:client/:id" name="ServiceLineMapping" component={Full} />
            <PrivateRoute path="/taxonomy-mapping/users/:client/:id" name="Map" component={Full} />
            <PrivateRoute path="/taxonomy-mapping/:client?" name="TaxonomyMapping" component={Full} />
            {/* End of Taxonomy mapping routes */}
            <PrivateRoute path="/marketing-notices/list" name="MarketingNotices" component={Full} />
            <PrivateRoute path="/marketing-notices/edit" name="EditMarketingNotices" component={Full} />
            <PrivateRoute path="/workflows" name="Workflows" component={Full} />
            <PrivateRoute path="/workflows/edit" name="WorkflowEdit" component={Full} />
            <PrivateRoute path="/wfsetup/auto-assign/create" name="AutoAssignEdit" component={Full} />
            <PrivateRoute path="/wfsetup/escalation/create" name="EscalationEdit" component={Full} />
            <PrivateRoute path="/tutorials" name="Tutorials" component={Full} />
            <PrivateRoute path="/unmatched" name="Unmatched Enforcements" component={Full} />
            <PrivateRoute path="/regulator-notices/search" name="RegulatorNoticesSearch" component={Full} />
            <PrivateRoute path="/regulator-notices/edit" name="RegulatorNoticesEdit" component={Full} />
            <PrivateRoute path="/regulator-notices/create" name="RegulatorNoticesCreate" component={Full} />
            <PrivateRoute path="/notifications" name="Notifications" component={Full} />
            <PrivateRoute path="/document-details" name="DocumentDetails" component={Full} />
            <PrivateRoute path="/service-lines-mapping" name="ServiceLinesMapping" component={Full} />
            <PrivateRoute path="/regulatory-categories-mapping" name="RegulatoryCategoriesMapping" component={Full} />

            <PrivateRoute path="/filters-edit" name="Edit Filter" component={Full} />
            <PrivateRoute path="/filters-create" name="Create Filter" component={Full} />

            <PrivateRoute path="/sl-autotags" name="ServiceLineSearchList" component={Full} />
            <PrivateRoute path="/sl-autotag/create/:search_id?" name="ServiceLineSearch" component={Full} />

            {/* <PrivateRoute path="/user/notifications/:folder?" name="My Inbox" component={Full} />
          <PrivateRoute path="/user/notification/details" name="NotificationDetails" component={Full} />
          <PrivateRoute path="/user/notification/create" name="NotificationCreate" component={Full} /> */}

            <PrivateRoute path="/preferences" name="Preferences" component={Full} />
            <PrivateRoute path="/riskfusion" name="RiskFusion" component={Full} />
            <PrivateRoute path="/regulator-report" name="RegulatorReport" component={Full} />

            <PrivateRoute path="/controlled-job-functions" name="ControlledJobFunctions" component={Full} />
            <PrivateRoute path="/verify-compliance-form/:token" name="ComplianceTrackerForm" component={Full} />

            <PrivateRoute path="/business-impact-map" name="BusinessImpactMap" component={Full} />
            <PrivateRoute path="/disambiguated-text" name="DisambiguatedText" component={Full} />

            <PrivateRoute path="/fines-list" name="FinesList" component={Full} />
            <PrivateRoute path="/fine-details" name="FineDetails" component={Full} />

            <PrivateRoute path="/loss-report" name="ManageLossReport" component={Full} />
            <PrivateRoute path="/loss-report-list" name="LossReportList" component={Full} />

            <PrivateRoute path="/themes" name="ThemesList" component={Full} />
            <PrivateRoute path="/theme/:id" name="ThemeUpdate" component={Full} />

            <PrivateRoute path="/client-taxonomies" name="ClientTaxonomysList" component={Full} />
            <PrivateRoute path="/client-taxonomy/:id/:title" name="ClientTaxonomyUpdate" component={Full} />

            <PrivateRoute path="/finra-rules/:id" name="RegulationTaggingScreen" component={Full} />
            <PrivateRoute path="/finra-rules" name="RegulationTaggingList" component={Full} />
            <PrivateRoute path="/finra-visualisation/:id" name="VisualisationDetails" component={Full} />
            <PrivateRoute path="/finra-visualisation" name="VisualisationFilters" component={Full} />

            <PrivateRoute path="/theme-dashboard-config" name="ThemeDashboardConfig" component={Full} />
            <PrivateRoute path="/dashboards/list" name="DashboardList" component={Full} />

            <PrivateRoute path="/test-dashboard" name="TestDashboard" component={Full} />
            <PrivateRoute path="/worldmap" name="Worldmap" component={Full} />

            <PrivateRoute path="/watchlist" name="Regulation Watch List" component={Full} />


            <PrivateRoute path="/api-viewer/authorities" name="API Viewer Authorities" component={Full} />
            <PrivateRoute path="/api-viewer/regulations/:id/:title" name="API Viewer Regulations" component={Full} />
            <PrivateRoute path="/api-viewer/versions/:id/:title" name="API Viewer Versions" component={Full} />
            <PrivateRoute path="/api-viewer/content/:id" name="API Viewer Content" component={Full} />

            <PrivateRoute path="/workflow-routing/:id" name="UserRoutingRules" component={Full} />
            <PrivateRoute path="/workflow-routing" name="UserRouting" component={Full} />

            <PrivateRoute path="/auto-tasks/:id" name="AutoTasksCreate" component={Full} />
            <PrivateRoute path="/auto-tasks" name="AutoTasks" component={Full} />

            <PrivateRoute path="/legal-entities" name="LegalEntities" component={Full} />

            <PrivateRoute path="/queues" name="MyQueue" component={Full} />

            <PrivateRoute path="/user-groups" name="UserGroups" component={Full} />
            <PrivateRoute path="/user-groups/create" name="UserGroupsCreate" component={Full} />
            <PrivateRoute path="/user-groups/update/:id" name="UserGroupsUpdate" component={Full} />

            <PrivateRoute path="/esg-tracker" name="ESGTracker" component={Full} />
            <PrivateRoute path="/fincrime-tracker" name="ESGTracker" component={Full} />

            <PrivateRoute path="/push-api/:id" name="PushApiDetails" component={Full} />
            <PrivateRoute path="/push-api" name="PushApi" component={Full} />

            <PrivateRoute path="/reg-access-group/:id" name="RegulationTagDetails" component={Full} />
            <PrivateRoute path="/reg-access-group" name="RegulationTags" component={Full} />

            <PrivateRoute path="/regulation-assessments" name="RegulationAssessments" component={Full} />
            <PrivateRoute path="/all-obligations" name="AllObligations" component={Full} />

            <PrivateRoute path="/procedures" name="Procedures" component={Full} />
            <PrivateRoute path="/controls" name="Controls" component={Full} />
            <PrivateRoute path="/procedures-watchlist" name="ProceduresWatchlist" component={Full} />

            <Redirect from="/usage" to="/usage/client-views" />
            <Redirect from="/assessments" to="/assessments/list" />

            <Redirect from="/admin/clients" to="/clients" />
            <Redirect from="/latest" to="/home" />
            {/* {AuthService.isLoggedIn() ?
            <span>
              {AuthService.checkAccess('regMonitoring') &&
                <Redirect from="/" to="/latest" />
              }
              {!AuthService.checkAccess('regMonitoring') &&
                <Redirect from="/" to="/covid" />
              }
            </span>
            :
            <Redirect from="/" to="/latest" />
            } */}
            <Redirect from="/" to="/home" />

            <Route path="*" component={Page404} />
          </Switch>
        </Router>
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={true}
        />
      </div>
    );
  }
}

console.log('Version: ' + VERSION);
store.set('version', VERSION);

//export default hot(module)(App);

ReactDOM.render(<App />, document.getElementById("root"));



// WEBPACK FOOTER //
// ./src/index.js